<div class="notification" id="openNotify" #openNotify>
  <div
    class="notify-icon"
    (click)="notification.emitCloseDialog('close')"
    id="notify"
  >
    <mat-icon matSuffix class="material-icons-outlined" id="notify">
      notifications
    </mat-icon>
  </div>
  <div class="notification__wrapper">
    <!-- close icon on responsive -->
    <mat-icon
      (click)="notification.emitCloseDialog('close')"
      class="close-icon"
    >
      close
    </mat-icon>
    @if (!loading && !!notifications) {
    <div class="notification__wrapper__header">
      <div class="header-actions">
        <mat-slide-toggle [(ngModel)]="toggleOff" (click)="toggle(!toggleOff)">
        </mat-slide-toggle>
        <p>عرض الغير مقروءة فقط</p>
      </div>
      @if (!markingAllAsRead) {
      <button class="mark-all-btn" (click)="markAllAsRead()" [disabled]="allNotificationsRead">
        <mat-icon>done_all</mat-icon>
        <span>قراءة الكل</span>
      </button>
      } @else {
      <button class="mark-all-btn loading" disabled>
        <mat-icon class="spinner-icon">refresh</mat-icon>
        <span>جاري القراءة...</span>
      </button>
      }
    </div>
    } @if (!loading && notifications.length > 0) {
    <div class="notification__wrapper__content">
      <div class="notification__wrapper__content_wrapper">
        <div class="notification__wrapper__content_wrapper__items">
          @for (notification of notifications; track $index; let i = $index) {
          <div class="w-100">
            @if (i >= 0 && (notification.createdAt | date) !=
            (notification.createdAt | date)) {
            <p class="date">
              {{ notification.createdAt | datePipe : "dddd" }}
            </p>
            } @if (notification) {
            <div
              [style]="{
                cursor: notification?.notificationType ? 'pointer' : 'default'
              }"
              class="notification__wrapper__content_wrapper__items-item"
              (click)="
                notification?.notificationType
                  ? goTo(
                      notification.notificationType,
                      +notification.operationId,
                      notification.id,
                      notification.extraType
                    )
                  : close()
              "
              [ngClass]="{ seen: !notification.seen }"
            >
              <p class="title body-large">{{ notification.title }}</p>
              <p class="message body-medium-2">{{ notification.message }}</p>
              <div *ngIf="!notification.seen">
                <i></i>
              </div>
              <mat-divider
                *ngIf="notifications.length - (i + 2) >= 0"
              ></mat-divider>
            </div>
            }
          </div>
          }
        </div>
        <div class="more_container" *ngIf="hasMoreNotifications">
          <div class="more" (click)="loadMore()">المزيد ...</div>
        </div>
      </div>
    </div>

    }@else {
    <div class="no-notify" *ngIf="!loading && notifications.length == 0">
      لا يوجد اشعارات بعد ...
    </div>
    }
    <div class="spinner" *ngIf="loading">
      <app-spinner
        [customLoader]="true"
        [bgColor]="secondaryColor"
      ></app-spinner>
    </div>
  </div>
</div>
